import { title } from "process";

export const CreditAlertsColumns = [
    {title: "Alert Type"},
    {title: "Threshold Amount"},
    {title: "Trigger Count"},
    {title: "Created At"},
    {title: "Actions"},
]